import React from 'react';

import { twMerge } from 'tailwind-merge';

import Icon from 'components/icon/icon';

import Typography from 'components-new/typography/typography';

import useGetFreelancerDiplomas from 'state/remote/remote-freelancer/use-get-freelancer-diplomas';
import type { Document } from 'state/__generated__/tadaahAPI';

type DiplomaListProps = {
  handleDeleteDiploma: (doc: Document) => void;
};

const DiplomaList: React.FC<DiplomaListProps> = (props) => {
  const { handleDeleteDiploma } = props;

  const { data } = useGetFreelancerDiplomas();

  const diplomaItemClassName = twMerge(
    'h-10 w-full flex justify-between',
    'mt-6 bg-white items-center',
    'text-gray600 border border-gray100 px-4',
    'shadow-8',
  );

  return (
    <>
      {data &&
        data.length > 0 &&
        data.map((item) => {
          return (
            <div key={item.id} className={diplomaItemClassName}>
              <Typography
                as="h5"
                variant="body-medium-bold"
                className="flex justify-start h-full items-center overflow-x-scroll max-w-[90%] whitespace-nowrap"
              >
                {item.name}
              </Typography>
              <Icon
                icon="trash"
                size={20}
                className="cursor-pointer"
                onClick={() => handleDeleteDiploma(item)}
              />
            </div>
          );
        })}
    </>
  );
};
export default DiplomaList;
